import { BiologicalSex, PractitionerProfession, ShareMethod } from '../types';
import jsonCountryMap from './countries.json';

export const countries: { [index: string]: string } = jsonCountryMap;

export const countryOptions = Object.entries(countries).map(([key, value]) => ({
  label: value,
  value: key,
}));

export const professionOptions = [
  { label: 'Acupuncturist', value: PractitionerProfession.acupuncturist },
  { label: 'Chiropractor', value: PractitionerProfession.chiropractor },
  { label: 'Dentist', value: PractitionerProfession.dentist },
  { label: 'Naturopath', value: PractitionerProfession.naturopath },
  { label: 'Nurse practitioner', value: PractitionerProfession.nurse_practitioner },
  { label: 'Oncologist', value: PractitionerProfession.oncologist },
  { label: 'Physician', value: PractitionerProfession.physician },
  { label: 'Physical therapist', value: PractitionerProfession.physical_therapist },
  { label: 'Radiologist', value: PractitionerProfession.radiologist },
];

export const shareStudyViaOptions = [
  { label: 'Email', value: ShareMethod.email },
  { label: 'Fax', value: ShareMethod.fax },
  { label: 'CD', value: ShareMethod.cd },
  { label: 'USB', value: ShareMethod.usb },
];

export const genderOptions = [
  { label: 'Female', value: BiologicalSex.female },
  { label: 'Male', value: BiologicalSex.male },
];

export const scanOptions = [
  { label: 'Torso', value: '100' },
  { label: 'Head and Torso', value: '200' },
  { label: 'Whole Body', value: '300' },
];

export const scanReasons = [
  {
    value: 'family',
    label: 'Family History of Cancer',
  },
  {
    value: 'previous',
    label: 'Previous Diagnosis',
  },
  {
    value: 'genetic',
    label: 'Genetic Risk of Cancer',
  },
  {
    value: 'fear',
    label: 'Fear of Cancer or Major Illness',
  },
  {
    value: 'surgery',
    label: 'Prior Surgery or Organ Transplant',
  },
  {
    value: 'risk',
    label: 'Over 50, Thus Increased Disease Risk',
  },
  {
    value: 'pain',
    label: 'Persistently Feel Unwell or Have Pain With No Explanation',
  },
];
